import Article from './Aside.vue';

export default Article



// WEBPACK FOOTER //
// ./src/components/parts/blog/aside/index.ts